// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { PageLoadingSpinner } from 'ui_kit_qmd'
import errorIcon from '../../images/common/error-icon.svg'
import AccountSettingsPageTitle from './AccountSettingsPageTitle/AccountSettingsPageTitle'
import { ErrorAlert } from '../../components/ui_kit_quickMD/error-alert/erroralert'
import { AccountSection } from './AccountSection/AccountSection'
import './account-settings.scss'
import { ConfirmationPopup } from '../../components/confirmation-popup/confirmationpopup'
import { LOGOUT } from '../../app/authState'
import {
  ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_BODY_TEXT,
  ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_CANCEL_BTN_TEXT,
  ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_SAVE_BTN_TEXT,
  ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_TITLE_TEXT,
  ACCOUNT_SETTINGS_RELOAD_PAGE_POP_UP_TEXT,
  ACCOUNT_SETTINGS_ROUTE,
  IS_SIDE_PANEL_COLLAPSED_KEY,
  PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY,
} from '../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  setAdminError,
  setIsEditSuccess,
  setIsProfileInfoEditSuccess,
} from '../../store/accountSettings/AccountSettingsActions'
import { getAdminProfile } from '../../store/accountSettings/AccountSettingsThunk'
import { sendCustomSentryMessage } from '../../utils/sentryUtility'

const errorToastWrapContainerStyle = {
  marginLeft: 'auto',
  marginRight: 'auto',
  top: 0,
  zIndex: 10,
  position: 'absolute',
  left: 0,
  right: 0,
}
const errorToastContainerStyle = { width: 550 }
const confirmationPopUpBoxStyle = { marginTop: 200 }
const AccountSettings = memo(() => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.accountSettings.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.accountSettings.error)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const isEditSuccess = useSelector((state) => state.accountSettings.isEditSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const isProfileInfoEditSuccess = useSelector((state) => state.accountSettings.isProfileInfoEditSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.accountSettings.adminProfile)

  const [isEditMode, setIsEditMode] = useState(false)
  const [isChangedData, setIsChangedData] = useState(false)
  const [newActiveTab, setNewActiveTab] = useState('')
  const [isConfirmationPopUpOpened, setIsConfirmationPopUpOpened] = useState(false)
  const [saveChangesFromPopUp, setSaveChangesFromPopUp] = useState(false)
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [isFirstRender, setIsFirstRender] = useState(true)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const toggleIsEditMode = useCallback((newStatus) => {
    setIsEditMode(newStatus)
    localStorage.setItem(PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY, JSON.stringify(false))
  }, [])

  useEffect(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getAdminProfile())
  }, [])

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (newActiveTab.redirect) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (newActiveTab.redirect === 'logout') {
        setNewActiveTab('')
        dispatch({ type: LOGOUT })
        sendCustomSentryMessage('Logout sidebar clicked from account settings, profile changed')
        localStorage.setItem(IS_SIDE_PANEL_COLLAPSED_KEY, JSON.stringify(false))
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        navigate(`/${newActiveTab.redirect}`, { replace: true })
        setNewActiveTab('')
      }
      setSaveChangesFromPopUp(false)
    } else if (saveChangesFromPopUp) {
      setSaveChangesFromPopUp(false)
      toggleIsEditMode(false)
    }
  }, [profile])
  useEffect(() => {
    if (isProfileInfoEditSuccess) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (!newActiveTab.redirect || !saveChangesFromPopUp) toggleIsEditMode(false)
      setIsChangedData(false)
      dispatch(setIsEditSuccess(false))
      dispatch(setIsProfileInfoEditSuccess(false))
    }
    setIsFirstRender(false)
  }, [isProfileInfoEditSuccess])

  useEffect(() => {
    if (isEditSuccess) {
      toggleIsEditMode(false)
      dispatch(setIsEditSuccess(false))
      dispatch(setIsProfileInfoEditSuccess(false))
    }
  }, [dispatch, isEditSuccess, toggleIsEditMode])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(setAdminError())
      }, 3500)
    }
  }, [error, dispatch])

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  useEffect(() => {
    window.onbeforeunload = () => {
      if (isChangedData) {
        return ACCOUNT_SETTINGS_RELOAD_PAGE_POP_UP_TEXT
      }
    }
    if (isChangedData) {
      window.history.pushState({}, '', ACCOUNT_SETTINGS_ROUTE)
      window.onpopstate = () => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        window.history.forward(1)
        setIsConfirmationPopUpOpened(true)
      }
    } else if (isEditMode) {
      window.history.pushState({}, '', ACCOUNT_SETTINGS_ROUTE)
      window.onpopstate = () => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        window.history.forward(1)
        setIsEditMode(false)
      }
    } else {
      if (localStorage.getItem(PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY)) {
        // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
        if (!JSON.parse(localStorage.getItem(PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY))) {
          window.history.pushState({}, '', ACCOUNT_SETTINGS_ROUTE)
        }
      }
      window.onpopstate = () => {
        if (localStorage.getItem(PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY)) {
          // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
          if (JSON.parse(localStorage.getItem(PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY))) {
            localStorage.setItem(PREVIOUS_OPENED_TABS_ACCOUNT_SETTINGS_PAGE_KEY, JSON.stringify(false))
          } else {
            // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
            window.history.back(2)
          }
        }
      }
    }
    return () => {
      window.onbeforeunload = () => {}
      return null
    }
  }, [isChangedData, isEditMode])

  const confirmationPopUpCancelBtnClick = useCallback(() => {
    toggleIsEditMode(false)
    setIsConfirmationPopUpOpened(false)
    setIsChangedData(false)
    if (newActiveTab) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (newActiveTab.redirect === 'logout') {
        setNewActiveTab('')
        dispatch({ type: LOGOUT })
        sendCustomSentryMessage('Logout sidebar clicked from account settings')
        localStorage.setItem(IS_SIDE_PANEL_COLLAPSED_KEY, JSON.stringify(false))
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        navigate(`/${newActiveTab.redirect}`, { replace: true })
        setNewActiveTab('')
      }
    }
  }, [dispatch, navigate, newActiveTab, toggleIsEditMode])
  const confirmationPopUpCloseActionClick = useCallback(() => {
    setIsConfirmationPopUpOpened(false)
    setNewActiveTab('')
  }, [])
  const confirmationPopUpSaveBtnClick = useCallback(() => {
    setSaveChangesFromPopUp(true)
  }, [])

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const reloadSection = () => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getAdminProfile())
  }

  return (
    <div>
      {isConfirmationPopUpOpened ?
        // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
        <ConfirmationPopup
          title={ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_TITLE_TEXT}
          primaryBtnAction={confirmationPopUpSaveBtnClick}
          primaryBtnText={ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_SAVE_BTN_TEXT}
          popUpBoxStyle={confirmationPopUpBoxStyle}
          secondaryBtnAction={confirmationPopUpCancelBtnClick}
          secondaryBtnText={ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_CANCEL_BTN_TEXT}
          msg={ACCOUNT_SETTINGS_CONFIRMATION_POP_UP_BODY_TEXT}
          closeAction={confirmationPopUpCloseActionClick}
        />
      : null}
      <div>
        {error && error !== getUserFriendlyErrorMessage(errorCodes.DEFAULT) ?
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          <div style={errorToastWrapContainerStyle}>
            <ErrorAlert
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              styleContainer={errorToastContainerStyle}
              errorText={error}
              errorImg={errorIcon}
              imgAlt='Error'
            />
          </div>
        : null}
        {loading ?
          <PageLoadingSpinner />
        : null}
        <div className='settings-page-container-main'>
          {/*
           // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
          {!isEditMode && <AccountSettingsPageTitle isEditMode={isEditMode} toggleIsEditMode={toggleIsEditMode} />}
          <AccountSection
            isEditMode={isEditMode}
            toggleIsEditMode={toggleIsEditMode}
            setNewActiveTab={setNewActiveTab}
            newActiveTab={newActiveTab}
            isChangedData={isChangedData}
            setIsChangedData={setIsChangedData}
            setSaveChangesFromPopUp={setSaveChangesFromPopUp}
            saveChangesFromPopUp={saveChangesFromPopUp}
            setIsConfirmationPopUpOpened={setIsConfirmationPopUpOpened}
          />
        </div>
      </div>
    </div>
  )
})

export default AccountSettings
